const usuarioClientedatosArchetype = [
    // HIDDEN ONES
    {key: 'id_pk', type: 'hidden'},
    {key: 'idusuario_fk', type: 'hidden'},
    {key: 'id_ultimo_usuario_fk', type: 'hidden'},

    // FECHAS
    [
        {key: 'fechanacimiento', type: 'date', label: 'Fecha nacimiento'},
        {key: 'fechaingreso', type: 'date', label: 'Fecha ingreso', readonly: true},
    ],

    [
        {key: 'miembrosfamilia', label: 'Miembros familia', type: 'text'},
        {key: 'miembrosmenores', label: 'Miembros menores', type: 'text'},
    ],

    // [
        {key: 'surtir', type: 'hidden'},
        {key: 'surtirart', type: 'hidden'},
    // ],
    [
        {key: 'diaentrega', label: 'Día de entrega', type: 'text'},
        {key: 'horaentrega1', label: 'Hora de entrega', _type: 'time'},
        {key: 'horaentrega2', label: 'Límite de entrega', _type: 'time'}
    ],
    
    [{key: 'ultima_actualizacion', readonly: true, type: 'text'}],
    
    null,

    // TELÉFONOS
    [
        {key: 'telefono', type: 'phone', label: 'Teléfono'},
        {key: 'telefonomovil', type: 'phone', label: 'Teléfono móvil'},
        {key: 'telefonooficina', type: 'phone', label: 'Teléfono oficina'},
    ],

    null,
    

    
    // TEXTUALS
    [
        // SELECT
        {key: 'idestado_fk', label: 'Estado'},
        {key: 'ciudad'},
        {key: 'colonia'},
    ],
    {key: 'calle', type: 'textarea'},
    [
        {key: 'numero', label: 'Número'},
        {key: 'codigopostal', label: 'Código Postal'},
    ],
    
    null,

    {key: 'detalles', type: 'textarea'},
];
export { usuarioClientedatosArchetype }